"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var BoxShadows = {
  softShadowUp: '0px -5px 15px rgba(0, 0, 0, 0.1)',
  softShadowCenter: '0px 0px 20px rgba(0, 0, 0, 0.14)',
  softShadowDown: '0px 5px 15px rgba(0, 0, 0, 0.1)',
  hardShadowUp: '0px -2px 4px rgba(0, 0, 0, 0.5)',
  hardShadowCenter: '0px 0px 6px rgba(0, 0, 0, 0.95)',
  hardShadowDown: '0px 2px 4px rgba(0, 0, 0, 0.5)'
};
var _default = BoxShadows;
exports.default = _default;